export const getAlbumCaption = ({
    albumCount,
    photoCount,
    translate
}: {
    albumCount?: number;
    photoCount: number;
    translate: SpAngularJs.ITranslateFilter;
}) => {
    if (albumCount !== undefined && albumCount > 0) {
        return translate(albumCount === 1 ? 'oneAlbum' : 'multipleAlbums', {
            albumCount: String(albumCount)
        });
    }

    if (!photoCount) {
        return translate('zeroPhotos');
    }

    return translate(photoCount === 1 ? 'onePhoto' : 'multiplePhotos', {
        photoCount: String(photoCount)
    });
};

/**
 * Scopes a translate filter to the download-destination strings, so components translating
 * bare keys can still reach them.
 */
export const getDownloadDestinationsTranslate =
    (translate: SpAngularJs.ITranslateFilter): SpAngularJs.ITranslateFilter =>
    (id, interpolateParams) =>
        translate(`client.gallery.downloadDestinations.${id}`, interpolateParams);

const getCountPhrase = (
    count: number,
    keyPrefix: 'photoCount' | 'videoCount',
    translate: SpAngularJs.ITranslateFilter
) => {
    if (count < 1) {
        return null;
    }

    if (count === 1) {
        return translate(`${keyPrefix}One`);
    }

    return translate(`${keyPrefix}Many`, { [keyPrefix]: String(count) });
};

/**
 * Names what a download contains: "12 Photos", "1 Video", "12 Photos and 3 Videos". Null when
 * there is nothing to name, which callers read as "keep the generic copy".
 */
export const getMediaCountCaption = ({
    photoCount,
    videoCount,
    translate
}: {
    photoCount: number;
    videoCount: number;
    translate: SpAngularJs.ITranslateFilter;
}) => {
    const photos = getCountPhrase(photoCount, 'photoCount', translate);
    const videos = getCountPhrase(videoCount, 'videoCount', translate);

    if (photos && videos) {
        return translate('mixedCount', { photos, videos });
    }

    if (photos) {
        return photos;
    }

    return videos;
};
